<template>
  <div class="page">
    <!-- TODO transiting between page types better -->
    <transition name="medium-fade">
      <place v-if="activePage && activePage.type === 'place'"/>
      <video-page v-if="activePage && activePage.type === 'video'"/>
      <live v-if="activePage && activePage.type === 'live'"/>
    </transition>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Live from '@/views/Live'
import Place from '@/components/Place'
import VideoPage from '@/components/VideoPage'

export default {
  name: 'page',

  components: { Live, Place, VideoPage },

  computed: {
    ...mapGetters({
      activePage: 'activePage',
      activeProperties: 'property/activeProperties',
      priceRanges: 'filter/priceRanges',
      lotSizeRanges: 'filter/lotSizeRanges',
      dwellingSizeRanges: 'filter/dwellingSizeRanges'
    })
  },

  watch: {
    $route: {
      handler () {
        if (this.activeProperties.length) {
          // set filter ranges
          this.$store.commit('filter/SET_FILTER_PARAMETERS', {
            inputPriceRange: this.priceRanges,
            inputLotSizeRange: this.lotSizeRanges,
            inputDwellingSizeRange: this.dwellingSizeRanges,
            inputBeds: false,
            inputBaths: false,
            inputCars: false,
            inputLotNumber: '',
            inputBuilder: ''
          })
        }
      },
      immediate: true
    }
  }
}
</script>
